const toDatetimeStr = (utcDatetimeStr) => {
  let date = new Date(utcDatetimeStr);
  return date.toLocaleString('ja-JP', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

function formatDateTime(date) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${year}/${month}/${day} ${hours}:${minutes}`;
}

function formatDate(date) {
  if (date === undefined){
    return
  }
  if (typeof date === 'string') {
    date = new Date(date)
  }
  return date.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).replace('-', '/')
}

function formatYearMonthInJapaneseText(date) {
  if (typeof date === "string") {
    date = new Date(date);
  }
  const formatter = new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "long",
  });

  return formatter.format(date);
}

function formatDateInJapaneseText(date) {
  if (typeof date === 'string') {
    date = new Date(date)
  }
  const formatter = new Intl.DateTimeFormat('ja-JP', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return formatter.format(date)
}

function formatDateTimeJapanese(date) {
  if (typeof date === 'string') {
    date = new Date(date)
  }
  const formatter = new Intl.DateTimeFormat('ja-JP', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });

  return formatter.format(date)
}

export const getDaysInMonth = (year, month, getLastMonth = false) => {
  if (getLastMonth) {
    month--;
    if (month < 1) {
      month = 12;
      year--;
    }
  }
  return new Date(year, month, 0).getDate();
}

export const getPreviousMonth = () => {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())
}

export const isPast = (date) => {
  const today = new Date();
  const day = today.getDate()
  return date <= day;
};

export const formatTime = (datetime) => {
  if (datetime === undefined || datetime === null) {
    return "-";
  }
  const timePart = datetime.split("T")[1];
  const [hour, minute] = timePart.split(":");
  return `${hour}:${minute}`;
};

export {
  formatDateTime,
  formatDate,
  toDatetimeStr,
  formatDateInJapaneseText,
  formatDateTimeJapanese,
  formatYearMonthInJapaneseText,
};
